/**
 * @version:               1.0.0
 * @createTime:            2021.10.08
 * @updateTime:            2021.10.08
 * @author:                zhangju
 * @description
 ***/

import ccTab from '@/components/common/tab/index.vue';
import contentTable from '@/components/common/more-tab-content/content-table-03/index.vue';
export default {
    name: 'page-list',
    components: {ccTab, contentTable},
    data() {
        return {
            tabList: [
                {
                    name: '仲裁简介',
                    code: 'zcjj'
                },
                {
                    name: '案例分析',
                    code: 'alfx'
                },
                {
                    name: '研究报告',
                    code: 'yjbg'
                }
            ],
            active: 'zcjj'
        };
    },
    computed: {
        crumbsList() {
            const list = [{
                name:'海事仲裁',
                key:'hszc',
                path:'/hszc'
            }];
            const listItem = this.tabList.filter(item => item.code === this.active)[0];
            listItem.key = listItem.code;
            list.push(listItem);
            return Object.freeze(list);
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.active = this.$route.query.tab || 'zcjj';
        },
        // 页签切换
        handelTabChange(code) {
            this.active = code;
        }
    }
};
